import './index.scss';
import UserHeader from './UserHeader';
import SchoolModal from './SchoolModal';
import SchoolSelector from '@app/redux/school/school.selector';
import * as schoolActions from '@app/redux/school/school.action';
import { useSelector, useDispatch } from 'react-redux';
import SchoolListSelect from '../Shares/SchoolSelect/SchoolListSelect';
import ChangePasswordPopup from '@app/components/Shares/ChangePasswordPopup';
import MenuPopover from './MenuPopover';

const MainHeader = () => {
    const dispatch = useDispatch();
    const isShowModal = useSelector(SchoolSelector.isShowModal);

    const closeModal = () => {
        dispatch(schoolActions.closeSchoolModal());
    };

    return (
        <>
            <div className="navbar navbar-fixed-top">
                <MenuPopover />
                <div className="navbar-collapse collapse" id="navbar-mobile">
                    <p className="navbar-text">
                        <span className="text-bold">
                            DỊCH VỤ SỔ SÁCH BÁN TRÚ
                        </span>
                    </p>

                    <UserHeader />
                    <div
                        className="nav navbar-nav navbar-right"
                        style={{ marginTop: '5px', minWidth: '400px' }}
                    >
                        <SchoolListSelect />
                    </div>
                    <SchoolModal show={isShowModal} onClose={closeModal} />
                </div>
            </div>
            <ChangePasswordPopup />
        </>
    );
};
export default MainHeader;
